export default __webpack_public_path__ + "static/media/jk-tanzim.1f0b3a4c.jpg";